import { MarkSpec, NodeSpec, Schema } from 'prosemirror-model';

export type SchemaPluginNodeMap = Record<string, NodeSpec>;
export type SchemaPluginMarkMap = Record<string, MarkSpec>;

export class SchemaPlugin<Nodes extends SchemaPluginNodeMap = {}, Marks extends SchemaPluginMarkMap = {}> {
  marks: Marks = {} as Marks;
  nodes: Nodes = {} as Nodes;
  props: Dictionary = {};

  addMarks(marks: Dictionary<MarkSpec>) {
    Object.assign(marks, this.marks);
  }

  addNodes(nodes: Dictionary<NodeSpec>) {
    Object.assign(nodes, this.nodes);
  }

  addProps(schema: Schema<Extract<keyof Nodes, string>, Extract<keyof Marks, string>>) {
    Object.assign(schema, this.props);
  }

  modifyNodesAndMarks(nodes: Dictionary<NodeSpec>, marks: Dictionary<MarkSpec>) { }
}
